const environment = {
  ENDPOINT_CAPIRENTBACKEND: "https://backend.datamain.homierent.com",
  NUMBER_WHATSAPP: process.env.REACT_APP_NUMBER_WHATSAPP,
}
export default environment
